module.exports = __webpack_public_path__ + "static/media/result-bg.497d2285.webp";